module.exports = __webpack_public_path__ + "static/media/mew-RINKEBY.da561fa4.png";